import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ExtrasSoldReportModel} from "./extras-sold-report.model";


@Component({
    selector: "extras-sold-report",
    templateUrl: "./extras-sold-report.component.html",
    providers: [provideReportModel(ExtrasSoldReportModel)]
})
export class ExtrasSoldReportComponent extends AbstractReportPage {
    constructor(public model: ExtrasSoldReportModel) {
        super();
    }
}
